import styled from '@emotion/styled';

const ModalConfirmSaveQuoteStyle = styled('div')`
    .contentModal {
        color: var(--sand-700);
        font-size: 16px;
        font-weight: 400;
    }
    .quoteTitle {
        color: var(--blue-400);
        font-size: 16px;
        font-weight: 400;
    }
    .btnEdit {
        margin-right: 16px;
    }
    .groupBtn {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-top: 24px;
    }
`;

export default ModalConfirmSaveQuoteStyle;
